import * as requestFromServer from './accessRoleCrud';
import { accessRoleSlice, callTypes } from './accessRoleSlice';
import { actions as auth } from '../../../Auth/_redux/authRedux'
import { toastOption } from '../../../../../_metronic/_helpers/ToastHelpers'
import { toast } from 'react-toastify'

const { actions } = accessRoleSlice;

export const fetchAccessRoles = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.findAccessRole(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.accessRolesFetched({ total_items, items }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchRoleMaster = () => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
        .getMaterAccessRole()
        .then((response) => {
            dispatch(actions.roleMasterFetched({ roleMaster: response.data.roleMaster }));
        })
        .catch((error) => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};


export const fetchAccessRole = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.accessRoleFetched({ accessRoleForEdit: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getAccessRoleById(id)
        .then(response => {
            const { data: accessRole } = response.data; // alias data -> donatur
            dispatch(actions.accessRoleFetched({ accessRoleForEdit: accessRole }));
        }).catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const createAccessRole = (accessRoleForCreation) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.createAccessRole(accessRoleForCreation)
        .then(response => {
            dispatch(actions.accessRoleReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const updateAccessRole = (accessRole) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updateAccessRole(accessRole)
        .then(response => {
            dispatch(actions.accessRoleReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};


export const deleteAccessRole = (accessRole) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.deleteAccessRole(accessRole)
        .then(response => {
            dispatch(actions.accessRoleReload);
            return response.data;
        })
        .catch(error => {
            if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            }
            error = error.response.data.message;
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};
